
export const LAYER_OPACITY_CONFIG = {
  "soil-raster-layer": { key: "Soil", type: "raster" },
  "windGust-layer": { key: "windGust", type: "raster" },
  "windSpeed-layer": { key: "windSpeed", type: "raster" },
  "precipitations-layer": { key: "precipitations", type: "raster" },
  "hourly-precipitations-layer": {
    key: "hourlyPrecipitations",
    type: "raster",
  },
  "temperature-layer": { key: "temperature", type: "raster" },
  "relative-humidity-layer": { key: "relativeHumidity", type: "raster" },
  "mean-sea-level-pressure-layer": {
    key: "meanSeaLevelPressure",
    type: "raster",
  },
  "cloud-cover-layer": { key: "cloudCover", type: "raster" },
  "deadFuel-layer": { key: "deadFuel", type: "raster" },
  "dem-raster-layer": { key: "demLevel", type: "raster" },
  "lai-raster-layer": { key: "leafAreaIndex", type: "raster" },
  "vegetation-height-raster-layer": {
    key: "vegetationHeight",
    type: "raster",
  },
  "biomass-raster-layer": { key: "biomass", type: "raster" },
  "total-fuel-load-raster-layer": { key: "totalFuelLoad", type: "raster" },
  "bare-soil-raster-layer": { key: "bareSoil", type: "raster" },
  "coniferous-raster-layer": { key: "coniferous", type: "raster" },
  "shrubland-raster-layer": { key: "shrubland", type: "raster" },
  "cropland-raster-layer": { key: "cropland", type: "raster" },
  "broadleaf-raster-layer": { key: "broadleaf", type: "raster" },
  "pine-raster-layer": { key: "pine", type: "raster" },
  "oak-raster-layer": { key: "oak", type: "raster" },
  "mixed-forest-raster-layer": { key: "mixedForest", type: "raster" },
  "grassland-raster-layer": { key: "grassland", type: "raster" },
  "urban-raster-layer": { key: "urban", type: "raster" },
  "water-layer": "water",
};

// Initial opacity values
export const INITIAL_OPACITIES = {
  Régions: 100,
  Départements: 100,
  Soil: 100,
  windSpeed: 100,
  precipitations: 100,
  hourlyPrecipitations: 100,
  temperature: 100,
  relativeHumidity: 100,
  meanSeaLevelPressure: 100,
  windGust: 100,
  bareSoil: 100,
  broadleaf: 100,
  mixedForest: 100,
  pine: 100,
  oak: 100,
  biomass: 100,
  leafAreaIndex: 100,
  totalFuelLoad: 100,
  vegetationHeight: 100,
  water: 100,
  urban: 100,
  coniferous: 100,
  shrubland: 100,
  cropland: 100,
  grassland: 100,
  geoJsonResult1: 100,
  geoJsonResult2: 100,
  geoJsonResult3: 100,
  geoJsonResult4: 100,
  demLevel: 100,
  deadFuel: 100,
  cloudCover: 100,
};
